import { types } from 'mobx-state-tree';

// Types
import { Pharmacy } from '@common/models/pharmacies/types';

export default types.optional(types.map(types.frozen<Pharmacy>()), {});
